// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import { AutoSizer, Table, Column } from 'react-virtualized'
// API
import api from '../../../apiClient/v1'
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
// Style
import classNames from 'classnames/bind'
import * as cssModal from '../../diferencias-inventarios/modal.css'
let css = classNames.bind(cssModal)

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = { visible: false }
        this.show  = ()=> this.setState({visible: true})
        this.hide  = ()=> this.setState({visible: false})
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalGenerarOC extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false,
            numeroOC: ''
        }
        this.onNumeroChange = (key, evt)=>{
            this.setState({numeroOC: evt.target.value})
        }
        this.handleSubmit = (evt)=>{
            this.setState({bloqueado: true})
            evt.preventDefault()
            evt.stopPropagation()
            this.setState(()=>{
                    this.context.agregarOrdenCompra(this.state.numeroOC)
                    .then(()=>{
                        this.setState({bloqueado: false})
                        this.props.hideModal()
                    })
                    .catch(error=>{
                        console.log("error")
                    })
            })
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={css('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Información de facturación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className={'list-group'}>
                        <strong>Unidades</strong>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.props.sumaUnidades}</span>
                            Total unidades
                        </li>
                    </ul>
                    <strong>Valores</strong>
                    <ul className={'list-group'}>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>${this.props.valorNeto}</span>
                            Valor neto
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>${this.props.valorBruto}</span>
                            Valor final
                        </li>
                    </ul>
                    <div>
                        <form onSubmit={this.handleSubmit}>
                            <label> Indíque número orden de compra</label>
                            <input type="number" className={'form-control'} placeholder="Número orden compra"
                                   value={this.state.numeroOC}
                                   onChange={this.onNumeroChange.bind(this, 'numeroOC')}
                                   required
                            />
                            <div></div>
                            <br></br>
                            <strong>Se enviará una copia de esta confirmación a los siguientes correos</strong>
                            <ul className={'list-group'}>
                                <li className={'list-group-item'}>crivera@sb.cl, ptejeda@sb.cl, paviles@sb.cl, rmunozp@sb.cl</li>
                                <li className={'list-group-item'}>mgamboa@seiconsultores.cl, gbriones@seiconsultores.cl</li>
                            </ul>
                            <br></br>
                            <button type={'submit'} className={'btn btn-primary'} disabled={this.state.bloqueado}>Enviar OC</button>
                            <button type={'button'} className={'btn btn-secondary'} onClick={this.props.hideModal}>Cancelar</button>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}
ModalGenerarOC.contextTypes = {
    agregarOrdenCompra: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/inventarios-facturacion/peticionOC/Modales.jsx